export default "__VITE_ASSET__CZznatah__"